import { Component } from '@angular/core';
import { FadeInAnimation } from './Animations/FadeInAnimation';
import { RouterOutlet } from '@angular/router';

import { OAuthService } from 'angular-oauth2-oidc';
import { JwksValidationHandler } from 'angular-oauth2-oidc';
import { AuthConfiguration } from './Auth/Config';
// import { AuthService } from './Auth/AuthService';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.less'],
    animations: [
        FadeInAnimation
    ]
})
export class AppComponent {
    /**
     * Список функций, которые будут выполнены единожды после аутентификации
     * List functions, that will be invoked once after authentication
     */
    static afterLoginedOnce: Array<{ (): void }> = [];
    static oauthServiceStatic: OAuthService
    constructor(
        public oauthService: OAuthService
    ) {
        AppComponent.oauthServiceStatic = oauthService;
        this.ConfigureImplicitFlowAuthentication();
    }

    private ConfigureImplicitFlowAuthentication() {
	
        this.oauthService.configure(AuthConfiguration);
        
        this.oauthService.tokenValidationHandler = new JwksValidationHandler();
        
        this.oauthService.loadDiscoveryDocument().then(doc => {
            this.oauthService.tryLogin()
                .catch(err => {
                    console.error(err);
                })
                .then(() => {
                    if(!this.oauthService.hasValidAccessToken()) {
                        this.oauthService.initImplicitFlow()
                    } else {
                        setInterval(() => {
                            AppComponent.afterLoginedOnce.forEach(_once => {
                                _once();
                                AppComponent.afterLoginedOnce = AppComponent.afterLoginedOnce.filter(x => x != _once)
                            })
                        }, 1000)
                    }
                });
        });
    }
    
    /**
     * Настроить переходы маршрутизатора и добавить анимации;
     * Configure router pages changing and append animations
     * @event
     * @param outlet - Аутлет маршрутизатора; Router outlet
     */
    prepareRoute(outlet: RouterOutlet) {
        return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'];
    }
}